var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 298.667h85.333V384h-85.333zm0 170.666h85.333v256h-85.333zm42.667-384C276.48 85.333 85.333 276.48 85.333 512S276.48 938.667 512 938.667 938.667 747.52 938.667 512 747.52 85.333 512 85.333m0 768c-188.16 0-341.333-153.173-341.333-341.333S323.84 170.667 512 170.667 853.333 323.84 853.333 512 700.16 853.333 512 853.333"
  })));
};
export default SvgInfo;